import React from 'react'

import { getClassesFromMarginsProp } from '../../utils/utils'

import BundleSelector from '../bundle-selector/bundle-selector.component'

import './bundle-grid.styles.scss'

const BundleGrid = ({
  currentBundle,
  bundlesData,
  margins,
  clickHandler,
  popUpClickHandler,
  ...otherProps
}) => {
  const marginClasses = getClassesFromMarginsProp(margins)

  return (
    <div className={`bundle-grid ${marginClasses}`} onClick={clickHandler}>
      <ul className='bundle-selectors'>
        {bundlesData.map((bundle) => (
          <BundleSelector
            key={bundle.id}
            bundle={bundle}
            currentBundle={currentBundle}
            clickHandler={popUpClickHandler}
          />
        ))}
      </ul>
    </div>
  )
}

export default BundleGrid
